// @flow
import ArchiverClientApi from "../API/archiverClientApi";
import {gotMagTypes, gotSampleTypes, gotProfilesList} from "../GUI_COMMON/ACTIONS/commonClientActions";
import ArchiverGuiUtils from "./ArchiverGuiUtils";
import {gotLocations} from "../ACTIONS/clientActions";

/**
 * get all profiles from the server and setup the global store with them.
 */
export function setupProfilesAndSampleAndMagType(dispatch) {
    ArchiverClientApi.getProfiles().then(({profiles}) => {
        dispatch(gotProfilesList(profiles)); // []
        ArchiverClientApi.sendSampleTypesRequest().then( (sampleTypes) => {
            dispatch(gotSampleTypes(sampleTypes));
            ArchiverClientApi.sendMagTypesRequest().then( (magTypes) => {
                dispatch(gotMagTypes(magTypes));
                ArchiverClientApi.getLocations(true).then( (locations) => {
                    dispatch(gotLocations(locations));      // locations and their departments
                })
            })
            .catch( responseError => ArchiverGuiUtils.ShowErrorIfNotUnauthourized(responseError));
        })
        .catch( responseError => ArchiverGuiUtils.ShowErrorIfNotUnauthourized(responseError));
    })
    .catch( responseError => ArchiverGuiUtils.ShowErrorIfNotUnauthourized(responseError));
}